__turbopack_context__.v({
  "max-width": "_8rXRGW_max-width",
  "placeholder": "_8rXRGW_placeholder",
  "svg": "_8rXRGW_svg",
});
